<template>
<div class="nj-input-simple-select">
    <div class="nj-input-simple-select--label">{{ label }}</div>
    <select class="nj-input-simple-select--items" :disabled="disabled" @change="change($event)">
        <option v-for="item in source" :key="item[itemKey]" :value="item[itemValue]">{{ labelFunction(item) }}</option>
    </select>
</div>
</template>
<script>
export default {
    name: "InputSimpleSelect",
    props: {
        value: null,
        label: {
            type: String,
            default: "Label"
        },
        itemKey: {
            type: String,
            required: true
        },
        itemValue: {
            type: String,
            required: true
        },
        source: {
            type: Array,
            default: []
        },
        labelFunction: {
            type: Function,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    components: {

    },
    computed: {

    },
    watch: {

    },
    data() {
        return {

        }
    },
    methods: {
        change(event) {
            this.$emit("input", event.target.value)
            this.$emit("change")
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.nj-input-simple-select {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0;
    margin: 0 0 6px 0;
}

.nj-input-simple-select--label {
    display: block;
    padding: 6px 4px;
}

.nj-input-simple-select--items {
    color: #666;
    width: 100%;
    outline: none;
    border: 1px solid #ccc;
    padding: 3px 6px;
    box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.1);
    font-size: var(--font-size);
    border-radius: var(--radius);

    display: flex;
    align-items: center;
    gap: 2px;
}
</style>